module.exports = __webpack_public_path__ + "img/Projekt.6a2e790b.png";